module.exports = __webpack_public_path__ + "static/img/bushes-before-min.9a40092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/bushes-before-min.png
// module id = 650
// module chunks = 64